import { MOBILE_QUERY } from '@/lib/breakpoints';
import { useMediaQuery } from '@/lib/useMediaQuery';

export type ViewMode = 'table' | 'cards';

/**
 * The file browser's card/table layout — derived strictly from viewport
 * width, never chosen.
 *
 * **Cards, unconditionally, below 1024px; table at and above it.** A table
 * down there only ever scrolled horizontally — `DataTable`'s own
 * `overflow-x-auto` carrying a grid built for a cursor onto a screen worked
 * with a thumb — so there was never a real choice at that width, only a
 * dead end one tap away. There is no toggle and nothing persisted: the
 * layout is a function of `isMobile` and nothing else.
 */
export function useViewMode(): ViewMode {
  const isMobile = useMediaQuery(MOBILE_QUERY);
  return isMobile ? 'cards' : 'table';
}
